import { render } from "./Calendar.vue?vue&type=template&id=096b9945&scoped=true"
import script from "./Calendar.vue?vue&type=script&lang=js"
export * from "./Calendar.vue?vue&type=script&lang=js"

import "./Calendar.vue?vue&type=style&index=0&id=096b9945&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-096b9945"

export default script